module.exports = __webpack_public_path__ + "static/media/redux.b51d1861.png";